import { 
    Box,
    Input,
    InputGroup,
    InputLeftElement,
    Flex,
    Button,
    useToast

} from '@chakra-ui/react'
import React, {useState} from 'react'
import { FiSearch } from "react-icons/fi";
import AllSearchTags from '../../component/AllSearchTags';
import axios from 'axios'
import { Auth } from '../../component/Auth';

const OrderItemSearchTag = () => {
    const [tData, setTData] = useState([])
    const [isLoading, setIsLoading] = useState({loading: false, error: false})
    const [searchTagInput, setSearchTagInput] = useState('')
    const [tenureData, setTenureData] = useState([])
    const toast = useToast()
  const searchHandler = (e) => {
    e.preventDefault()
    setIsLoading({loading: true, error: false})
    let data = JSON.stringify({
      "tags": searchTagInput.trim().split(',')
    });
    
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/search/order-tags`,
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data : data
    };
    
    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      setTData(response.data)
       // fetching all tenure details ------------
       if(response.data.length > 0){
        let data3 = JSON.stringify({
          "orderId": response.data[0].orderId,
        });
  
        let config3 = {
          method: 'post',
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure/get-tenure-list`,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': Auth()
          },
          data: data3
        };
  
        axios.request(config3)
          .then((response) => {
            setTenureData(response.data)
            if (response.data.length === 0) {
              toast({
                title: `Tenure data not found`,
                position: 'top',
                status: 'warning',
                duration: 5000,
                isClosable: true,
              })
            }
          })
          .catch((error) => {
            console.log(error);
          });
       }
       
      setIsLoading({loading: false, error: false})
    })
    .catch((error) => {
      console.log(error);
      setIsLoading({loading: false, error: true})
    });
    
  }
  return (
    <Box width={'80%'} p={5}>
    {/* ## Header ## */}
    <Flex justifyContent={'flex-start'} alignItems={'center'} flexDirection={'column'} w={'full'}>
          <Box w={'100%'} maxW={'45%'}>
          <form>
              <InputGroup>
                <InputLeftElement
                  pointerEvents="none"
                  children={<FiSearch />}
                  size="xs"
                  mt={-1}
                />
                <Input
                  placeholder='Search Order Items by tags...'
                  bgColor={'white'}
                  rounded={'full'}
                  size={'sm'}
                  autoComplete={'off'}
                  onChange={(e) => setSearchTagInput(e.target.value)} />
              </InputGroup>
              <Button type={'submit'} isLoading={isLoading.loading} colorScheme={'blue'} size={'sm'} w={'full'} rounded={'md'} shadow={'md'} mt={2} onClick={searchHandler}>Search</Button>
          </form>
            </Box>
        </Flex>

        {/* ## Search Result Body ## */}
        
        <AllSearchTags 
            head={['Order ID', 'Tenure ID', 'Product Id', 'Title','Final Price',  'Status']}
            data={tData}
            tenureData={tenureData}
            isLoading={isLoading}
        />

    </Box>
  )
}

export default OrderItemSearchTag